<template>
  <div>
    
    <div class="input-group-btn"> 
      <input class="timepicker form-control" />      
    </div>
    
  </div>
</template>
<script>

export default {  
  mounted: function() {  
    $(this.$el).find('.timepicker').mask('00:00:00',{
      onblur: (cep) => {
        this.$emit('update-time', cep)
      }
    })    
  },
  beforeDestroy: function() {    
    $(this.$el).find('hide').datepicker('destroy')
  }
}
</script>
